import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import resize from '@mailobj-browser/front/js/events/types/resize.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import {elements} from '../../styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import {rect} from "#utilities/js/fixed/fixed.js"
import {scrollTo} from "#components/generics/js/scroll/scrollTo.js"

export const offsetNotAtBottom = 300

const observers = new WeakMap()

const options = {
  childList: true,
}

const callback = ([{target}]) => {
  const div_chat_msgs_update = one('#div_chat_msgs_update', target)
  const chatMessagesInRefresh = one(`.${elements.messages_in}`, div_chat_msgs_update)
  const {ownerDocument} = target
  const chat = one(`.${elements.chat}`, ownerDocument)
  const chatMessages = one(`.${elements.messages}`, chat)
  const chatMessagesIn = one(`.${elements.messages_in}`, chat)
  const {scrollHeight} = chatMessagesIn
  const {scrollTop, clientHeight} = chat
  const {childNodes: childNodesRefresh} = chatMessagesInRefresh
  const {childNodes} = chatMessagesIn

  if (childNodesRefresh.length > childNodes.length) {
    chatMessagesIn.appendChild(childNodesRefresh[childNodesRefresh.length-1])

    if (scrollTop+clientHeight >= scrollHeight - offsetNotAtBottom) {
      scrollTo(chatMessages, { top: scrollHeight })
    }
  }
}

const observing = defaultView => {
  if (!observers.has(defaultView)) {
    const {MutationObserver} = defaultView
    const observer = new MutationObserver(callback)

    observers.set(defaultView, observer)
  }

  return observers.get(defaultView)
}

const resizeChat = (style, height) => {
  style.height = `${height}px`
}

const onResize = object(listener, {
  type: resize,
  passive,
  task: (
    currentTarget
  ) => {
    let container = currentTarget

    if (!currentTarget.classList) {
      const {ownerDocument: ownDoc} = container
      container = one(`.${elements.thread}`, ownDoc)
    }

    const {ownerDocument, style} = container
    const {defaultView} = ownerDocument
    const {innerHeight} = defaultView
    const {top} = rect(container)
    const height = innerHeight - top

    queueMicrotask(async () => {
      await resizeChat(style, height)

      const chatMessages = one(`.${elements.messages}`, container)
      const {scrollHeight} = one(`.${elements.messages_in}`, container)
      scrollTo(chatMessages, { top: scrollHeight })
    })
  }
})

export default container => {
  const {ownerDocument} = container
  const {defaultView} = ownerDocument

  onResize.task(container)
  onResize.listen(defaultView)

  // @todo A modifier quand les refreshs seront mis en fragment et nouveau bundle
  const div_REFRESH = one('#div_REFRESH', ownerDocument)
  // console.log(div_REFRESH);
  const observer = observing(defaultView)
  observer.observe(div_REFRESH, options)
}